import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';
import { ColumnDateDto } from './ColumnDateDto';
import { ColumnHtmlDto } from './ColumnHtmlDto';
import { ColumnNumberDto } from './ColumnNumberDto';
import { ColumnStringDto } from './ColumnStringDto';
import { ColumnTimeFrameDto } from './ColumnTimeFrameDto';

export class ColumnHyperlinkDto extends ColumnFieldTypeObject {
  TextFieldTypeObject: ColumnStringDto | ColumnNumberDto | ColumnDateDto | ColumnHtmlDto | ColumnTimeFrameDto;
  // todo: the type of dataDto should be updated to be generic
  HyperlinkCallback: (dataDto: object) => void;
  IsClickable: (dataDto: object) => boolean;

  constructor(init?: Partial<ColumnHyperlinkDto>) {
    super();
    this.FieldType = ColumnFieldType.HyperLink;
    this.IsClickable = (): boolean => {
      return true;
    };
    Object.assign(this, init);
  }
}
